var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "企业微信托管",
        visible: _vm.dialogVisible,
        width: "700px",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        closed: _vm.handleClosed,
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "login-info-wrap",
        },
        [
          _vm.boundDevices.length
            ? _c(
                "div",
                { staticClass: "bound-device-toolbar" },
                [
                  _c("span", { staticClass: "bound-device-toolbar__label" }, [
                    _vm._v("当前设备"),
                  ]),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "360px" },
                      attrs: { filterable: "" },
                      on: { change: _vm.handleBoundDeviceChange },
                      model: {
                        value: _vm.activeBoundDeviceId,
                        callback: function ($$v) {
                          _vm.activeBoundDeviceId = $$v
                        },
                        expression: "activeBoundDeviceId",
                      },
                    },
                    _vm._l(_vm.boundDevices, function (item) {
                      return _c("el-option", {
                        key: item.deviceId,
                        attrs: {
                          label: _vm.getDeviceLabel(item),
                          value: item.deviceId,
                        },
                      })
                    }),
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-plus" },
                      on: { click: _vm.handleAddDevice },
                    },
                    [_vm._v("添加设备")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.bindDevice
            ? _c(
                "div",
                { staticClass: "bind-status" },
                [
                  _c("el-alert", {
                    attrs: {
                      title: "已绑定设备",
                      type: "success",
                      closable: false,
                      "show-icon": "",
                    },
                  }),
                  _vm.profileSyncPending
                    ? _c(
                        "el-alert",
                        {
                          staticStyle: { "margin-top": "12px" },
                          attrs: {
                            type:
                              _vm.profileSyncTimedOut ||
                              _vm.bindDevice.profileSyncStatus === "TIMEOUT"
                                ? "warning"
                                : "info",
                            closable: false,
                            "show-icon": "",
                          },
                        },
                        [
                          _c(
                            "template",
                            { slot: "title" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.profileSyncing
                                      ? "登录成功，正在同步企微资料…"
                                      : "登录成功，资料同步较慢，可稍后继续刷新"
                                  ) +
                                  " "
                              ),
                              !_vm.profileSyncing
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.startPollingBindStatus()
                                        },
                                      },
                                    },
                                    [_vm._v("继续刷新")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass: "device-info",
                      staticStyle: { "margin-top": "20px" },
                    },
                    [
                      _c(
                        "el-descriptions",
                        { attrs: { column: 1, border: "" } },
                        [
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "设备名称" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.bindDevice.deviceName ||
                                    _vm.bindDevice.deviceId ||
                                    "未知设备"
                                )
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "企微昵称" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.profileSyncPending
                                    ? _vm.profileFieldPlaceholder
                                    : _vm.bindDevice.wecomNickname || "-"
                                )
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "企微账号" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.profileSyncPending
                                    ? _vm.profileFieldPlaceholder
                                    : _vm.bindDevice.phone || "-"
                                )
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "企微Id" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.profileSyncPending
                                    ? _vm.profileFieldPlaceholder
                                    : _vm.bindDevice.wecomUserId || "-"
                                )
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "设备状态" } },
                            [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: _vm.bindDevice.online
                                      ? "success"
                                      : "info",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.bindDevice.online ? "在线" : "离线"
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "企微状态" } },
                            [
                              _c(
                                "el-tag",
                                { attrs: { type: _vm.wecomStatusTagType } },
                                [_vm._v(_vm._s(_vm.wecomStatusText))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "notify-config",
                      staticStyle: { "margin-top": "20px" },
                    },
                    [
                      _c(
                        "el-card",
                        { attrs: { header: "掉线通知配置", shadow: "never" } },
                        [
                          _c(
                            "el-form",
                            {
                              attrs: { "label-width": "100px", size: "small" },
                            },
                            [
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "通知开关" } },
                                        [
                                          _c("el-switch", {
                                            attrs: {
                                              "active-text": "开启",
                                              "inactive-text": "关闭",
                                            },
                                            model: {
                                              value:
                                                _vm.notifyConfig.notifyEnabled,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.notifyConfig,
                                                  "notifyEnabled",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "notifyConfig.notifyEnabled",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "推送间隔" } },
                                        [
                                          _c("el-input-number", {
                                            staticClass:
                                              "readonly-input-number",
                                            staticStyle: { width: "120px" },
                                            attrs: {
                                              min: 5,
                                              max: 120,
                                              step: 5,
                                              controls: true,
                                              "controls-position": "right",
                                            },
                                            nativeOn: {
                                              keydown: function ($event) {
                                                $event.preventDefault()
                                              },
                                              mousewheel: function ($event) {
                                                $event.preventDefault()
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.notifyConfig
                                                  .notifyIntervalMinutes,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.notifyConfig,
                                                  "notifyIntervalMinutes",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "notifyConfig.notifyIntervalMinutes",
                                            },
                                          }),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "margin-left": "8px",
                                                color: "#909399",
                                                "font-size": "12px",
                                              },
                                            },
                                            [_vm._v("分钟")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "通知时间段" } },
                                [
                                  _c("el-time-picker", {
                                    staticStyle: { width: "110px" },
                                    attrs: {
                                      format: "HH:mm",
                                      "value-format": "HH:mm",
                                      placeholder: "开始",
                                      size: "small",
                                    },
                                    model: {
                                      value: _vm.notifyConfig.notifyStartTime,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.notifyConfig,
                                          "notifyStartTime",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "notifyConfig.notifyStartTime",
                                    },
                                  }),
                                  _c(
                                    "span",
                                    { staticStyle: { margin: "0 8px" } },
                                    [_vm._v("至")]
                                  ),
                                  _c("el-time-picker", {
                                    staticStyle: { width: "110px" },
                                    attrs: {
                                      format: "HH:mm",
                                      "value-format": "HH:mm",
                                      placeholder: "结束",
                                      size: "small",
                                    },
                                    model: {
                                      value: _vm.notifyConfig.notifyEndTime,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.notifyConfig,
                                          "notifyEndTime",
                                          $$v
                                        )
                                      },
                                      expression: "notifyConfig.notifyEndTime",
                                    },
                                  }),
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { "margin-left": "10px" },
                                      attrs: {
                                        type: "primary",
                                        size: "mini",
                                        loading: _vm.saveNotifyLoading,
                                      },
                                      on: { click: _vm.handleSaveNotifyConfig },
                                    },
                                    [_vm._v(" 保存 ")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "12px",
                                    color: "#909399",
                                    "line-height": "1.4",
                                    "padding-left": "100px",
                                  },
                                },
                                [
                                  _vm._v(
                                    " 说明：关闭通知或在非通知时间段内，企微掉线将不会推送消息提醒 "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  false
                    ? _c(
                        "div",
                        {
                          staticClass: "reset-tip",
                          staticStyle: {
                            "margin-top": "20px",
                            padding: "12px",
                            "background-color": "#E6F7FF",
                            border: "1px solid #91D5FF",
                            "border-radius": "4px",
                            color: "#0050B3",
                            "font-size": "13px",
                            "line-height": "1.6",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { "margin-bottom": "4px" } },
                            [
                              _vm._v(
                                "若您非自己操作掉线，请先点击【掉线优化】后再点击【重新绑定】扫码上线企微"
                              ),
                            ]
                          ),
                          _c("div", [
                            _vm._v(
                              "优化流程大约需要3-5分钟，优化后重新登录企微，可有效改善掉线情况！"
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass: "actions",
                      staticStyle: {
                        "margin-top": "12px",
                        "text-align": "center",
                      },
                    },
                    [
                      false
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-refresh",
                                loading: _vm.resetLoading,
                                disabled: _vm.resetLoading || _vm.rebindLoading,
                              },
                              on: { click: _vm.handleResetDevice },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.isResetting
                                    ? "优化中（点击查看进度）"
                                    : "掉线优化"
                                )
                              ),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            loading: _vm.rebindLoading,
                            disabled: _vm.isResetting,
                          },
                          on: { click: _vm.handleRebind },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.rebindLoading
                                ? "正在检测企微状态"
                                : "重新绑定"
                            )
                          ),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            loading: _vm.screenshotLoading,
                            disabled: _vm.isResetting,
                            type: "success",
                          },
                          on: { click: _vm.handleScreenshot },
                        },
                        [_vm._v("设备截屏")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "div",
                {
                  staticClass: "unbind-status",
                  staticStyle: { "text-align": "center", padding: "40px 0" },
                },
                [
                  _c("i", {
                    staticClass: "el-icon-mobile-phone",
                    staticStyle: {
                      "font-size": "60px",
                      color: "#909399",
                      "margin-bottom": "20px",
                    },
                  }),
                  _vm.selectedDeviceId
                    ? [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "16px",
                              color: "#606266",
                              "margin-bottom": "12px",
                            },
                          },
                          [_vm._v("请选择需要绑定的云手机")]
                        ),
                        _c(
                          "el-select",
                          {
                            staticStyle: {
                              width: "360px",
                              "margin-bottom": "16px",
                            },
                            attrs: { filterable: "" },
                            model: {
                              value: _vm.selectedDeviceId,
                              callback: function ($$v) {
                                _vm.selectedDeviceId = $$v
                              },
                              expression: "selectedDeviceId",
                            },
                          },
                          _vm._l(_vm.unboundDevices, function (item) {
                            return _c("el-option", {
                              key: item.deviceId,
                              attrs: {
                                label: item.deviceName || item.deviceId,
                                value: item.deviceId,
                                disabled: !item.online,
                              },
                            })
                          }),
                          1
                        ),
                        false
                          ? _c(
                              "div",
                              {
                                staticClass: "reset-tip",
                                staticStyle: {
                                  "margin-bottom": "12px",
                                  padding: "12px",
                                  "background-color": "#E6F7FF",
                                  border: "1px solid #91D5FF",
                                  "border-radius": "4px",
                                  color: "#0050B3",
                                  "font-size": "13px",
                                  "line-height": "1.6",
                                  "text-align": "left",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { "margin-bottom": "4px" } },
                                  [
                                    _vm._v(
                                      "若您非自己操作掉线，请先点击【掉线优化】后再点击【重新绑定】扫码上线企微"
                                    ),
                                  ]
                                ),
                                _c("div", [
                                  _vm._v(
                                    "优化流程大约需要3-5分钟，优化后重新登录企微，可有效改善掉线情况！"
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "actions unbound-reset-actions" },
                          [
                            false
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      icon: "el-icon-refresh",
                                      loading: _vm.resetLoading,
                                      disabled: _vm.resetLoading,
                                    },
                                    on: { click: _vm.handleResetDevice },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.isResetting
                                          ? "优化中（点击查看进度）"
                                          : "掉线优化"
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "el-button",
                              {
                                attrs: { disabled: _vm.isResetting },
                                on: { click: _vm.handleBind },
                              },
                              [_vm._v("立即绑定")]
                            ),
                            _vm.boundDevices.length
                              ? _c(
                                  "el-button",
                                  {
                                    on: { click: _vm.handleBackToBoundDevice },
                                  },
                                  [_vm._v("返回")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    : _vm.noExtraDevice
                    ? [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "16px",
                              color: "#606266",
                              "margin-bottom": "30px",
                            },
                          },
                          [_vm._v(" 没有多余的云手机进行绑定 ")]
                        ),
                        _vm.boundDevices.length
                          ? _c(
                              "el-button",
                              { on: { click: _vm.handleBackToBoundDevice } },
                              [_vm._v("返回已绑定设备")]
                            )
                          : _vm._e(),
                      ]
                    : _vm.noExtraDeviceno
                    ? [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "16px",
                              color: "#606266",
                              "margin-bottom": "30px",
                            },
                          },
                          [_vm._v(" 云手机不在线 ")]
                        ),
                        _vm.boundDevices.length
                          ? _c(
                              "el-button",
                              { on: { click: _vm.handleBackToBoundDevice } },
                              [_vm._v("返回已绑定设备")]
                            )
                          : _vm._e(),
                      ]
                    : [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "16px",
                              color: "#606266",
                              "margin-bottom": "30px",
                            },
                          },
                          [_vm._v(" 暂未绑定企业微信托管云手机设备 ")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.handleBind },
                          },
                          [_vm._v("立即绑定")]
                        ),
                      ],
                ],
                2
              ),
        ]
      ),
      _c("WxLogin", {
        attrs: { visible: _vm.wxLoginVisible, deviceId: _vm.selectedDeviceId },
        on: {
          "update:visible": function ($event) {
            _vm.wxLoginVisible = $event
          },
          loginSuccess: _vm.handleLoginSuccess,
        },
      }),
      false
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.resetModalTitle,
                visible: _vm.resetModalVisible,
                width: "500px",
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                "append-to-body": "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.resetModalVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "reset-modal-content" },
                [
                  _vm.resetProgress && _vm.resetProgress.status === "RUNNING"
                    ? [
                        _c(
                          "div",
                          {
                            staticClass: "reset-progress-tip",
                            staticStyle: {
                              "margin-bottom": "16px",
                              "text-align": "center",
                              color: "#606266",
                              "font-size": "14px",
                            },
                          },
                          [
                            _vm._v(
                              " 掉线优化进行中，可关闭弹窗后台运行，请优化完毕后再登录 "
                            ),
                          ]
                        ),
                        _c("el-progress", {
                          attrs: {
                            percentage: Number(_vm.resetProgress.percent || 0),
                            status: _vm.resetProgressStatus,
                            format: _vm.formatResetProgress,
                          },
                        }),
                        _c(
                          "div",
                          {
                            staticClass: "reset-progress-estimate",
                            staticStyle: {
                              "margin-top": "8px",
                              "text-align": "center",
                              color: "#C0C4CC",
                              "font-size": "12px",
                            },
                          },
                          [_vm._v(" 预计 3-5 分钟 ")]
                        ),
                      ]
                    : _vm._e(),
                  _vm.resetProgress && _vm.resetProgress.status === "FAILED"
                    ? [
                        _c("el-alert", {
                          attrs: {
                            title:
                              "抱歉，掉线优化处理失败，请点击重试按钮重启优化",
                            type: "error",
                            closable: false,
                            "show-icon": "",
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm.resetProgress && _vm.resetProgress.status === "SUCCESS"
                    ? [
                        _c("el-result", {
                          attrs: { icon: "success", title: "优化处理完毕！" },
                        }),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _vm.resetProgress && _vm.resetProgress.status === "RUNNING"
                    ? _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.resetModalVisible = false
                            },
                          },
                        },
                        [_vm._v(" 关闭 ")]
                      )
                    : _vm._e(),
                  _vm.resetProgress && _vm.resetProgress.status === "FAILED"
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            type: "warning",
                            icon: "el-icon-refresh",
                            loading: _vm.resetLoading,
                          },
                          on: { click: _vm.handleRetryReset },
                        },
                        [_vm._v(" 重试 ")]
                      )
                    : _vm._e(),
                  _vm.resetProgress && _vm.resetProgress.status === "SUCCESS"
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.resetModalVisible = false
                            },
                          },
                        },
                        [_vm._v(" 关闭 ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }